import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  fill: "none",
  viewBox: "0 0 15 15"
};
function t(d, e) {
  return o(), l("svg", n, [...e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.256 10.344a.69.69 0 0 1-.098-.975L6.96 4.754a.7.7 0 0 1 1.08 0l3.802 4.615a.69.69 0 0 1-.098.975.7.7 0 0 1-.98-.098L7.5 6.286l-3.263 3.96a.7.7 0 0 1-.981.098",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const c = { render: t };
export {
  c as default,
  t as render
};
